module.exports = __webpack_public_path__ + "img/ask-questions.e38fe910.png";